"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1251],{

/***/ 36927:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74512);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32735);
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58521);
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26025);
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(75320);
/* harmony import */ var _Icons_ChevronRightIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92255);
/* harmony import */ var _hooks_useTranslateMessage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75986);





function Breadcrumbs(param) {
    var items = param.items;
    var translate = (0,_hooks_useTranslateMessage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        "aria-label": "breadcrumbs",
        sx: {
            ".MuiBreadcrumbs-ol": {
                rowGap: "12px"
            }
        },
        separator: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icons_ChevronRightIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            reflectIfRtl: true,
            fontSize: "small"
        }),
        children: items.map(function(item) {
            var label = item.label;
            if (item.label.includes("***")) {
                var splitedBreadcrum = item.label.split("***");
                label = translate("breadcrumbs_in_label", {
                    keyword: splitedBreadcrum[0],
                    city: splitedBreadcrum[1]
                });
            }
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                href: item.url,
                color: "inherit",
                sx: {
                    textDecoration: "none"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    variant: "body2",
                    color: "primary.textBlack700",
                    children: decodeURI(label)
                })
            }, "breadcrumb-".concat(item.label, "-").concat(item.url));
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Breadcrumbs);


/***/ }),

/***/ 74022:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useBreadCrumbsSchema; }
});

// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
;// CONCATENATED MODULE: ./utils/schema/breadcrumbs.ts
var stage = "production";
function getBreadcrumbsSchema(breadcrumbs) {
    var suffix = stage === "production" ? "www." : "".concat(stage, ".");
    var itemListElement = breadcrumbs === null || breadcrumbs === void 0 ? void 0 : breadcrumbs.map(function(breadcrumb, index) {
        return {
            "@type": "ListItem",
            position: index + 1,
            item: {
                "@type": "WebPage",
                id: "https://".concat(suffix, "doctify.com").concat(breadcrumb.url),
                name: breadcrumb.label
            }
        };
    });
    return {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: itemListElement
    };
};

;// CONCATENATED MODULE: ./hooks/useBreadcrumbsSchema.ts


function useBreadCrumbsSchema(existingSchema, breadcrumbs) {
    return (0,react.useMemo)(function() {
        if (existingSchema) {
            var schemaObj = JSON.parse(existingSchema);
            if (breadcrumbs && breadcrumbs.length) {
                schemaObj.push(getBreadcrumbsSchema(breadcrumbs));
            }
            return JSON.stringify(schemaObj);
        }
        return JSON.stringify(getBreadcrumbsSchema(breadcrumbs));
    }, [
        existingSchema,
        breadcrumbs
    ]);
};


/***/ }),

/***/ 90170:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ useSpecialistPracticesContacts; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32735);

var useSpecialistPracticesContacts = function(specialistPractices) {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        if (!specialistPractices) {
            return {
                practicesWithBookingLink: [],
                practicesWithContactDetails: []
            };
        }
        return {
            practicesWithBookingLink: specialistPractices.filter(function(practice) {
                return practice.externalBookingLink;
            }),
            practicesWithContactDetails: specialistPractices.filter(function(practice) {
                var _ContactDetails = practice.ContactDetails, ContactDetails = _ContactDetails === void 0 ? [] : _ContactDetails;
                return ContactDetails.findIndex(function(cd) {
                    return [
                        "public",
                        "singlePointPublic"
                    ].includes(cd.type) && (cd.email || cd.phone);
                }) !== -1;
            })
        };
    }, [
        specialistPractices
    ]);
};


/***/ }),

/***/ 40531:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useSpecialistWorkingHours; },
/* harmony export */   "i": function() { return /* binding */ dayOfWeekMapping; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32735);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}

var dayOfWeekMapping = {
    monday: 1,
    tuesday: 2,
    wednesday: 3,
    thursday: 4,
    friday: 5,
    saturday: 6,
    sunday: 7
};
function useSpecialistWorkingHours(practices) {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return practices.reduce(function(prev, practice) {
            var workingOpeningHoursPractice = practice.workingOpeningHours, id = practice.id;
            var workingOpeningHours = workingOpeningHoursPractice || {};
            var res = _objectSpread({}, prev, {
                workingHours: _objectSpread({}, prev.workingHours, _defineProperty({}, id, workingOpeningHours))
            });
            Object.keys(workingOpeningHours).forEach(function(key) {
                var ref;
                if ((ref = workingOpeningHours[key]) === null || ref === void 0 ? void 0 : ref.length) {
                    var ref1;
                    res.workingHours.all[Number(key)] = (ref1 = res.workingHours.all[Number(key)]) === null || ref1 === void 0 ? void 0 : ref1.concat(workingOpeningHours[key]);
                    res.hasWorkingHours = true;
                }
            });
            return res;
        }, {
            workingHours: {
                all: {
                    1: [],
                    2: [],
                    3: [],
                    4: [],
                    5: [],
                    6: [],
                    7: []
                }
            },
            hasWorkingHours: false
        });
    }, [
        practices
    ]);
};


/***/ }),

/***/ 92422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "c": function() { return /* binding */ useVisibilityComponents; }
});

// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ./constants/profile.ts
var constants_profile = __webpack_require__(50081);
// EXTERNAL MODULE: ./providers/AppData/index.tsx
var AppData = __webpack_require__(3426);
// EXTERNAL MODULE: ./utils/practiceSpecialist.ts
var practiceSpecialist = __webpack_require__(99744);
// EXTERNAL MODULE: ./hooks/useSpecialistWorkingHours.ts
var useSpecialistWorkingHours = __webpack_require__(40531);
// EXTERNAL MODULE: ./hooks/useSpecialistPractices.ts
var useSpecialistPractices = __webpack_require__(90170);
// EXTERNAL MODULE: ./hooks/useKeywordsMapper.ts
var useKeywordsMapper = __webpack_require__(46311);
;// CONCATENATED MODULE: ./utils/getPlanProfile.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}

var planIncludes = function(profile, plans) {
    return plans.some(function(plan) {
        var ref;
        return (ref = profile.plan) === null || ref === void 0 ? void 0 : ref.includes(plan);
    });
};
var getIsUnclaimedPlan = function(profile, type) {
    if (!profile) {
        return null;
    }
    var _obj;
    var unclaimedPlans = (_obj = {}, _defineProperty(_obj, constants_profile/* ProfileTypes.SPECIALIST */.ub.SPECIALIST, [
        constants_profile/* SpecialistPlans.UNCLAIMED */.FS.UNCLAIMED,
        constants_profile/* SpecialistPlans.NO_PLAN */.FS.NO_PLAN
    ]), _defineProperty(_obj, constants_profile/* ProfileTypes.PRACTICE */.ub.PRACTICE, [
        constants_profile/* PracticePlans.UNCLAIMED */.cj.UNCLAIMED,
        constants_profile/* PracticePlans.NO_PLAN */.cj.NO_PLAN
    ]), _obj);
    return planIncludes(profile, unclaimedPlans[type] || []);
};
var getIsProOrExpertProPlan = function(profile, type) {
    if (!profile) {
        return null;
    }
    var _obj;
    var proPlans = (_obj = {}, _defineProperty(_obj, constants_profile/* ProfileTypes.SPECIALIST */.ub.SPECIALIST, [
        constants_profile/* SpecialistPlans.EXPERT */.FS.EXPERT,
        constants_profile/* SpecialistPlans.EXPERT_PRO */.FS.EXPERT_PRO
    ]), _defineProperty(_obj, constants_profile/* ProfileTypes.PRACTICE */.ub.PRACTICE, [
        constants_profile/* PracticePlans.ENTRY */.cj.ENTRY,
        constants_profile/* PracticePlans.UNCLAIMED */.cj.UNCLAIMED
    ]), _obj);
    if (type === constants_profile/* ProfileTypes.PRACTICE */.ub.PRACTICE) {
        return !planIncludes(profile, proPlans[type] || []);
    }
    return planIncludes(profile, proPlans[type] || []);
};

// EXTERNAL MODULE: ./utils/extractFacilitiesTypes.ts + 6 modules
var extractFacilitiesTypes = __webpack_require__(58692);
// EXTERNAL MODULE: ./hooks/useWpaTenant.ts
var useWpaTenant = __webpack_require__(68682);
;// CONCATENATED MODULE: ./hooks/useVisibilityComponents.ts










var isMediaIncludeEnabledArticle = function(type, media) {
    return !!(media === null || media === void 0 ? void 0 : media.some(function(post) {
        return post.type === type && post.enabled;
    }));
};
var useVisibilityComponents = function(param) {
    var specialist = param.specialist, practice1 = param.practice, address = param.address;
    var ref7, ref1;
    var language = (0,react.useContext)(AppData/* AppDataContext */.R).language;
    var ref2 = (0,useSpecialistWorkingHours/* default */.Z)((specialist === null || specialist === void 0 ? void 0 : specialist.practices) || []), specialistHasWoringHours = ref2.hasWorkingHours;
    var ref3 = (0,extractFacilitiesTypes/* default */.Z)((practice1 === null || practice1 === void 0 ? void 0 : practice1.practiceFacilities) || [], language), facilities = ref3.facilities, services = ref3.services, parking = ref3.parking;
    var practicesWithContactDetails = (0,useSpecialistPractices/* useSpecialistPracticesContacts */.t)((specialist === null || specialist === void 0 ? void 0 : specialist.practices) || []).practicesWithContactDetails;
    var ref4 = (0,useKeywordsMapper/* useKeywordsMapper */._)((specialist === null || specialist === void 0 ? void 0 : specialist.keywords) || (practice1 === null || practice1 === void 0 ? void 0 : practice1.keywords) || [], !!practice1), subSpecialties = ref4.subSpecialties, conditionAndTreatments = ref4.conditionAndTreatments;
    var isWPA = (0,useWpaTenant/* useWpaTenant */.c)().isWPA;
    var isUnclaimed = (0,react.useMemo)(function() {
        if (!!practice1 && !specialist) {
            return getIsUnclaimedPlan(practice1, constants_profile/* ProfileTypes.PRACTICE */.ub.PRACTICE);
        }
        if (!!specialist && !practice1) {
            return getIsUnclaimedPlan(specialist, constants_profile/* ProfileTypes.SPECIALIST */.ub.SPECIALIST);
        }
        return true;
    }, [
        practice1,
        specialist
    ]);
    var isBasic = (0,react.useMemo)(function() {
        return (specialist === null || specialist === void 0 ? void 0 : specialist.basic) || (practice1 === null || practice1 === void 0 ? void 0 : practice1.basic);
    }, [
        specialist,
        practice1
    ]);
    var fees = (0,react.useMemo)(function() {
        if (specialist) {
            var ref, ref5, ref6;
            return !isWPA && !isBasic && !isUnclaimed && !!((ref = specialist.consultationFees) === null || ref === void 0 ? void 0 : ref.currency) && (!!((ref5 = specialist.consultationFees) === null || ref5 === void 0 ? void 0 : ref5.followUp) || !!((ref6 = specialist.consultationFees) === null || ref6 === void 0 ? void 0 : ref6.new));
        }
        return false;
    // todo: clarify deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isBasic,
        isUnclaimed,
        specialist === null || specialist === void 0 ? void 0 : (ref7 = specialist.consultationFees) === null || ref7 === void 0 ? void 0 : ref7.currency
    ]);
    var insurers = (0,react.useMemo)(function() {
        var ref, ref8;
        return (!!(practice1 === null || practice1 === void 0 ? void 0 : (ref = practice1.insurers) === null || ref === void 0 ? void 0 : ref.length) || !!(specialist === null || specialist === void 0 ? void 0 : (ref8 = specialist.insurers) === null || ref8 === void 0 ? void 0 : ref8.length)) && !isBasic && !isWPA;
    }, [
        isBasic,
        isWPA,
        specialist === null || specialist === void 0 ? void 0 : specialist.insurers,
        practice1 === null || practice1 === void 0 ? void 0 : practice1.insurers
    ]);
    var about = (0,react.useMemo)(function() {
        var startPermission = !!(subSpecialties === null || subSpecialties === void 0 ? void 0 : subSpecialties.length) || !!(conditionAndTreatments === null || conditionAndTreatments === void 0 ? void 0 : conditionAndTreatments.length) || !!isUnclaimed || !!isBasic || !!fees || !!insurers;
        if (specialist) {
            var ref, ref9, ref10, ref11, ref12, ref13, ref14;
            return startPermission || !!((ref = specialist.about) === null || ref === void 0 ? void 0 : ref[language]) || !!((ref9 = specialist.statistic) === null || ref9 === void 0 ? void 0 : ref9.length) || !!((ref10 = specialist.registrationBodies) === null || ref10 === void 0 ? void 0 : ref10.length) || !!((ref11 = specialist.insurers) === null || ref11 === void 0 ? void 0 : ref11.length) || !!((ref12 = specialist.languages) === null || ref12 === void 0 ? void 0 : ref12.length) || !!((ref13 = specialist.education) === null || ref13 === void 0 ? void 0 : (ref14 = ref13[language]) === null || ref14 === void 0 ? void 0 : ref14.length);
        }
        if (practice1) {
            var ref15, ref16, ref17, ref18, ref19;
            return startPermission || !!((ref15 = practice1.about) === null || ref15 === void 0 ? void 0 : ref15[language]) || !!((ref16 = practice1.keywords) === null || ref16 === void 0 ? void 0 : ref16.length) || !!((ref17 = practice1.insurers) === null || ref17 === void 0 ? void 0 : ref17.length) || !!((ref18 = practice1.statistic) === null || ref18 === void 0 ? void 0 : ref18.length) || !!((ref19 = practice1.healthChecks) === null || ref19 === void 0 ? void 0 : ref19.length);
        }
        return false;
    // todo: clarify deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        conditionAndTreatments,
        isUnclaimed,
        isBasic,
        fees,
        insurers,
        specialist === null || specialist === void 0 ? void 0 : specialist.statistic,
        specialist === null || specialist === void 0 ? void 0 : specialist.registrationBodies,
        specialist === null || specialist === void 0 ? void 0 : specialist.insurers,
        specialist === null || specialist === void 0 ? void 0 : specialist.languages,
        practice1 === null || practice1 === void 0 ? void 0 : practice1.keywords,
        practice1 === null || practice1 === void 0 ? void 0 : practice1.insurers,
        practice1 === null || practice1 === void 0 ? void 0 : practice1.statistic,
        practice1 === null || practice1 === void 0 ? void 0 : practice1.healthChecks
    ]);
    var isProOrExpertPro = (0,react.useMemo)(function() {
        if (specialist) {
            return getIsProOrExpertProPlan(specialist, constants_profile/* ProfileTypes.SPECIALIST */.ub.SPECIALIST);
        }
        if (practice1) {
            return getIsProOrExpertProPlan(practice1, constants_profile/* ProfileTypes.PRACTICE */.ub.PRACTICE);
        }
        return false;
    }, [
        specialist,
        practice1
    ]);
    var peerRecommendations = (0,react.useMemo)(function() {
        return Boolean(specialist && specialist.peerRecommendationsCount);
    }, // todo: clarify deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        specialist,
        specialist === null || specialist === void 0 ? void 0 : specialist.peerRecommendations
    ]);
    var location = (0,react.useMemo)(function() {
        var ref21, ref20;
        return !!address || !!(specialist === null || specialist === void 0 ? void 0 : (ref21 = specialist.practices) === null || ref21 === void 0 ? void 0 : ref21.length) && (specialist === null || specialist === void 0 ? void 0 : (ref20 = specialist.practices) === null || ref20 === void 0 ? void 0 : ref20.some(function(practice) {
            var ref;
            return !!((ref = practice.address) === null || ref === void 0 ? void 0 : ref.geolocation);
        })) || !!(practice1 === null || practice1 === void 0 ? void 0 : practice1.address);
    }, [
        specialist === null || specialist === void 0 ? void 0 : specialist.practices,
        practice1,
        address
    ]);
    var reviewsTotal = (0,react.useMemo)(function() {
        return !!(practice1 === null || practice1 === void 0 ? void 0 : practice1.reviewsTotal) || !!(specialist === null || specialist === void 0 ? void 0 : specialist.reviewsTotal);
    }, [
        practice1 === null || practice1 === void 0 ? void 0 : practice1.reviewsTotal,
        specialist === null || specialist === void 0 ? void 0 : specialist.reviewsTotal
    ]);
    var gallery = (0,react.useMemo)(function() {
        var ref, ref22;
        return !!(practice1 === null || practice1 === void 0 ? void 0 : (ref = practice1.images) === null || ref === void 0 ? void 0 : (ref22 = ref.images) === null || ref22 === void 0 ? void 0 : ref22.length);
    }, [
        practice1 === null || practice1 === void 0 ? void 0 : (ref1 = practice1.images) === null || ref1 === void 0 ? void 0 : ref1.images
    ]);
    var practiceSpecialistName = (0,react.useMemo)(function() {
        var ref;
        return practice1 ? !!(0,practiceSpecialist/* getPracticeSpecialistName */.V)((ref = practice1.specialists) === null || ref === void 0 ? void 0 : ref[0], language) : false;
    }, // todo: clarify deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        practice1,
        practice1 === null || practice1 === void 0 ? void 0 : practice1.specialists
    ]);
    var languages = (0,react.useMemo)(function() {
        var ref;
        return !!(specialist === null || specialist === void 0 ? void 0 : (ref = specialist.languages) === null || ref === void 0 ? void 0 : ref.length);
    }, [
        specialist === null || specialist === void 0 ? void 0 : specialist.languages
    ]);
    // todo: clarify deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var mainPracticeName = (0,react.useMemo)(function() {
        var ref, ref23, ref24;
        return !!(specialist === null || specialist === void 0 ? void 0 : (ref = specialist.practices) === null || ref === void 0 ? void 0 : (ref23 = ref[0]) === null || ref23 === void 0 ? void 0 : (ref24 = ref23.name) === null || ref24 === void 0 ? void 0 : ref24[language]);
    }, [
        specialist === null || specialist === void 0 ? void 0 : specialist.practices
    ]);
    var hasWorkingHours = (0,react.useMemo)(function() {
        var ref, ref25;
        return specialistHasWoringHours || !!(practice1 === null || practice1 === void 0 ? void 0 : (ref = practice1.workingOpeningHours) === null || ref === void 0 ? void 0 : (ref25 = ref[1]) === null || ref25 === void 0 ? void 0 : ref25.length);
    }, [
        specialistHasWoringHours,
        practice1 === null || practice1 === void 0 ? void 0 : practice1.workingOpeningHours
    ]);
    var phone = (0,react.useMemo)(function() {
        return !!(practice1 === null || practice1 === void 0 ? void 0 : practice1.phone);
    }, [
        practice1 === null || practice1 === void 0 ? void 0 : practice1.phone
    ]);
    var practiceSpecialists = (0,react.useMemo)(function() {
        var ref;
        return !!(practice1 === null || practice1 === void 0 ? void 0 : (ref = practice1.specialists) === null || ref === void 0 ? void 0 : ref.length);
    }, [
        practice1 === null || practice1 === void 0 ? void 0 : practice1.specialists
    ]);
    var hideGetInTouch = (0,react.useMemo)(function() {
        var ref, ref26, ref27;
        return !(practicesWithContactDetails === null || practicesWithContactDetails === void 0 ? void 0 : practicesWithContactDetails.length) && !(!!(practice1 === null || practice1 === void 0 ? void 0 : (ref = practice1.phone) === null || ref === void 0 ? void 0 : ref.length) && !!(practice1 === null || practice1 === void 0 ? void 0 : (ref26 = practice1.email) === null || ref26 === void 0 ? void 0 : ref26.length) || !!(practice1 === null || practice1 === void 0 ? void 0 : (ref27 = practice1.plan) === null || ref27 === void 0 ? void 0 : ref27.includes(constants_profile/* PracticePlans.NO_PLAN */.cj.NO_PLAN)));
    }, [
        practicesWithContactDetails,
        practice1 === null || practice1 === void 0 ? void 0 : practice1.phone,
        practice1 === null || practice1 === void 0 ? void 0 : practice1.email,
        practice1 === null || practice1 === void 0 ? void 0 : practice1.plan
    ]);
    var hasSpecialistMedia = (0,react.useMemo)(function() {
        var ref;
        return !!(specialist === null || specialist === void 0 ? void 0 : (ref = specialist.media) === null || ref === void 0 ? void 0 : ref.length);
    }, [
        specialist === null || specialist === void 0 ? void 0 : specialist.media
    ]);
    var hasSpecialistMediaEnabled = (0,react.useMemo)(function() {
        var ref;
        return specialist === null || specialist === void 0 ? void 0 : (ref = specialist.media) === null || ref === void 0 ? void 0 : ref.reduce(function(acc, mediaItem) {
            if (mediaItem.type !== constants_profile/* MediaTypes.PUBLICATION */.Tr.PUBLICATION && mediaItem.enabled) {
                return true;
            }
            return acc;
        }, false);
    }, [
        specialist === null || specialist === void 0 ? void 0 : specialist.media
    ]);
    var hasPracticeMedia = (0,react.useMemo)(function() {
        var ref;
        return !!(practice1 === null || practice1 === void 0 ? void 0 : (ref = practice1.media) === null || ref === void 0 ? void 0 : ref.length);
    }, [
        practice1 === null || practice1 === void 0 ? void 0 : practice1.media
    ]);
    var hasPracticeMediaEnabled = (0,react.useMemo)(function() {
        var ref;
        return practice1 === null || practice1 === void 0 ? void 0 : (ref = practice1.media) === null || ref === void 0 ? void 0 : ref.reduce(function(acc, mediaItem) {
            if (mediaItem.type !== constants_profile/* MediaTypes.PUBLICATION */.Tr.PUBLICATION && mediaItem.enabled) {
                return true;
            }
            return acc;
        }, false);
    }, [
        practice1 === null || practice1 === void 0 ? void 0 : practice1.media
    ]);
    var practiceSocials = (0,react.useMemo)(function() {
        var ref;
        return practice1 === null || practice1 === void 0 ? void 0 : (ref = practice1.media) === null || ref === void 0 ? void 0 : ref.filter(function(post) {
            return !constants_profile/* mediaTypesWithoutSocials.includes */.kh.includes(post.type) && post.enabled;
        });
    }, [
        practice1 === null || practice1 === void 0 ? void 0 : practice1.media
    ]);
    var specialistSocials = (0,react.useMemo)(function() {
        var ref;
        return specialist === null || specialist === void 0 ? void 0 : (ref = specialist.media) === null || ref === void 0 ? void 0 : ref.filter(function(post) {
            return !constants_profile/* mediaTypesWithoutSocials.includes */.kh.includes(post.type) && post.enabled;
        });
    }, [
        specialist === null || specialist === void 0 ? void 0 : specialist.media
    ]);
    var isSpecialistMediaValid = (0,react.useMemo)(function() {
        return hasSpecialistMedia && hasSpecialistMediaEnabled;
    }, [
        hasSpecialistMedia,
        hasSpecialistMediaEnabled
    ]);
    var isPracticeMediaValid = (0,react.useMemo)(function() {
        return hasPracticeMedia && hasPracticeMediaEnabled;
    }, [
        hasPracticeMedia,
        hasPracticeMediaEnabled
    ]);
    var shouldShowMedia = (0,react.useMemo)(function() {
        return !isWPA && !isUnclaimed && isProOrExpertPro && (isSpecialistMediaValid || isPracticeMediaValid) && (specialistSocials || practiceSocials);
    }, [
        isWPA,
        isUnclaimed,
        isProOrExpertPro,
        isSpecialistMediaValid,
        isPracticeMediaValid,
        specialistSocials,
        practiceSocials
    ]);
    var media = (0,react.useMemo)(function() {
        return Boolean(shouldShowMedia);
    }, [
        shouldShowMedia
    ]);
    var checkMediaTypeAvailability = (0,react.useCallback)(function(type) {
        return media && (isMediaIncludeEnabledArticle(type, specialist === null || specialist === void 0 ? void 0 : specialist.media) || isMediaIncludeEnabledArticle(type, practice1 === null || practice1 === void 0 ? void 0 : practice1.media));
    }, [
        media,
        practice1 === null || practice1 === void 0 ? void 0 : practice1.media,
        specialist === null || specialist === void 0 ? void 0 : specialist.media
    ]);
    var videos = (0,react.useMemo)(function() {
        return checkMediaTypeAvailability(constants_profile/* MediaTypes.VIDEO */.Tr.VIDEO) || checkMediaTypeAvailability(constants_profile/* MediaTypes.PROFILE */.Tr.PROFILE);
    }, [
        checkMediaTypeAvailability
    ]);
    var articles = (0,react.useMemo)(function() {
        return checkMediaTypeAvailability(constants_profile/* MediaTypes.ARTICLE */.Tr.ARTICLE);
    }, [
        checkMediaTypeAvailability
    ]);
    var introductionVideoAvailable = isProOrExpertPro;
    var faqQuestions = {
        faqQuestionReviews: reviewsTotal,
        faqQuestionLanguages: languages,
        faqQuestionWhereLocated: mainPracticeName || practiceSpecialistName,
        faqQuestionsLocation: hasWorkingHours,
        faqQuestionAcceptVisits: !hideGetInTouch,
        faqQuestionPracticePhone: phone,
        faqQuestionConsultants: practiceSpecialists
    };
    var showServices = (0,react.useMemo)(function() {
        return !!services.length && !isUnclaimed;
    }, [
        isUnclaimed,
        services.length
    ]);
    var showFacilities = (0,react.useMemo)(function() {
        return !!facilities.length && !isUnclaimed;
    }, [
        isUnclaimed,
        facilities.length
    ]);
    var showParking = (0,react.useMemo)(function() {
        return !!parking.length && !isUnclaimed;
    }, [
        isUnclaimed,
        parking.length
    ]);
    var showBreadcrumbs = (0,react.useMemo)(function() {
        return !isWPA;
    }, [
        isWPA
    ]);
    return {
        about: about,
        articles: articles,
        fees: fees,
        insurers: insurers,
        location: location,
        reviews: true,
        services: showServices,
        facilities: showFacilities,
        parking: showParking,
        peerRecommendations: peerRecommendations,
        specialists: practiceSpecialists,
        gallery: gallery,
        faq: !isBasic && !isUnclaimed && !isWPA && Object.values(faqQuestions).some(function(value) {
            return value;
        }),
        faqQuestions: faqQuestions,
        videos: videos,
        media: media,
        introductionVideoAvailable: introductionVideoAvailable,
        showBreadcrumbs: showBreadcrumbs
    };
};


/***/ }),

/***/ 58692:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ utils_extractFacilitiesTypes; }
});

// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/_virtual/_tslib.esm.js
var _tslib_esm = __webpack_require__(10395);
// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/SvgIcon/SvgIcon.esm.js + 1 modules
var SvgIcon_esm = __webpack_require__(46224);
;// CONCATENATED MODULE: ../../../packages/hermes-web-components/lib/icons/Bed/index.esm.js




const BedIcon = (_a) => {
    var props = (0,_tslib_esm/* __rest */._)(_a, []);
    return (react.createElement(SvgIcon_esm/* default */.Z, Object.assign({ width: "24", height: "25", viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react.createElement("mask", { id: "path-1-inside-1_10490_3983", fill: "white" },
            react.createElement("rect", { x: "5.45508", y: "5.2959", width: "13.0909", height: "5.93939", rx: "1" })),
        react.createElement("rect", { x: "5.45508", y: "5.2959", width: "13.0909", height: "5.93939", rx: "1", stroke: "#051851", strokeWidth: "2.4", fill: "none", mask: "url(#path-1-inside-1_10490_3983)" }),
        react.createElement("path", { d: "M3.4 19.2959C3.4 19.6273 3.66863 19.8959 4 19.8959C4.33137 19.8959 4.6 19.6273 4.6 19.2959H3.4ZM4.13789 13.6169L3.62062 13.3129L4.13789 13.6169ZM5.76845 9.65856L3.62062 13.3129L4.65515 13.9209L6.80298 10.2666L5.76845 9.65856ZM3.4 14.1236V19.2959H4.6V14.1236H3.4ZM3.62062 13.3129C3.47617 13.5586 3.4 13.8385 3.4 14.1236H4.6C4.6 14.0523 4.61904 13.9823 4.65515 13.9209L3.62062 13.3129Z", fill: "#051851" }),
        react.createElement("path", { d: "M19.4006 19.2959C19.4006 19.6273 19.6692 19.8959 20.0006 19.8959C20.3319 19.8959 20.6006 19.6273 20.6006 19.2959H19.4006ZM19.8718 13.7921L19.3491 14.0865L19.8718 13.7921ZM17.1921 10.257L19.3491 14.0865L20.3946 13.4976L18.2376 9.66812L17.1921 10.257ZM19.4006 14.2828V19.2959H20.6006V14.2828H19.4006ZM19.3491 14.0865C19.3828 14.1464 19.4006 14.214 19.4006 14.2828H20.6006C20.6006 14.0077 20.5296 13.7373 20.3946 13.4976L19.3491 14.0865Z", fill: "#051851" }),
        react.createElement("path", { d: "M8.36328 10.4929V8.76563C8.36328 8.48948 8.58714 8.26562 8.86328 8.26562H11.9996M15.636 10.4929V8.76562C15.636 8.48948 15.4122 8.26562 15.136 8.26562H11.9996M11.9996 8.26562V10.4929", stroke: "#051851", strokeWidth: "1.2" }),
        react.createElement("path", { d: "M4 14.6292H20M4 18.1292H20", stroke: "#051851", strokeWidth: "1.2" })));
};



;// CONCATENATED MODULE: ../../../packages/hermes-web-components/lib/icons/MoneyBag/index.esm.js




const MoneyBagIcon = (_a) => {
    var props = (0,_tslib_esm/* __rest */._)(_a, []);
    return (react.createElement(SvgIcon_esm/* default */.Z, Object.assign({ width: "24", height: "25", viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react.createElement("path", { d: "M12.6411 21.0469H10.1463C8.5309 21.0469 7.06083 20.114 6.373 18.6523V18.6523C5.76813 17.367 5.85917 15.8621 6.61458 14.6591L10.1217 9.07364L8.59229 4.48535H15.4092L13.7487 9.07364L17.285 14.5534C18.0985 15.814 18.1798 17.4122 17.4984 18.7488V18.7488C16.7795 20.159 15.3303 21.0469 13.7473 21.0469H12.4573", stroke: "#051851", strokeWidth: "1.2", strokeLinecap: "round", strokeLinejoin: "round", fill: "none" }),
        react.createElement("rect", { x: "8.67969", y: "7.67578", width: "6.64209", height: "2.35969", rx: "1.17984", fill: "#051851" }),
        react.createElement("path", { d: "M13.9073 17.4066C14.2164 17.5156 14.2182 17.9559 13.9073 18.0596H10.4913C10.2601 18.0596 10.1611 17.766 10.3437 17.6243C10.5503 17.4136 10.7028 17.2054 10.8011 16.9994C10.8995 16.7888 10.9487 16.529 10.9487 16.2201C10.9487 16.1265 10.9364 16.0282 10.9118 15.9252H10.1002C9.82281 15.8444 9.82281 15.4514 10.1002 15.3705H10.7274C10.6241 15.0757 10.5724 14.7901 10.5724 14.514C10.5724 14.2004 10.6437 13.9289 10.7864 13.6995C10.929 13.4702 11.1258 13.2947 11.3766 13.173C11.6275 13.0466 11.9177 12.9834 12.2473 12.9834C12.7736 12.9834 13.172 13.1238 13.4425 13.4047C13.7131 13.6855 13.8532 14.0436 13.8631 14.4789C13.7702 14.8334 13.2854 14.8788 13.1284 14.5476L13.0958 14.4789C13.0958 14.2261 13.0269 14.0272 12.8892 13.8821C12.7514 13.7323 12.5375 13.6574 12.2473 13.6574C11.9817 13.6574 11.7677 13.73 11.6054 13.8751C11.448 14.0202 11.3693 14.2472 11.3693 14.5561C11.3693 14.6918 11.384 14.8229 11.4135 14.9493C11.443 15.0757 11.4849 15.2161 11.539 15.3705H12.9703C13.2673 15.4362 13.2673 15.8595 12.9703 15.9252H11.7087C11.7333 16.0328 11.7455 16.1335 11.7455 16.2271C11.7455 16.6811 11.5808 17.0743 11.2512 17.4066H13.9073Z", fill: "#051851" })));
};



;// CONCATENATED MODULE: ../../../packages/hermes-web-components/lib/icons/Accessibility/index.esm.js



const AccessibilityIcon = (props) => (react.createElement(SvgIcon_esm/* default */.Z, Object.assign({ width: "24", height: "25", viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    react.createElement("path", { d: "M9.7634 10.8047C9.05708 10.7925 8.35951 10.9623 7.73788 11.2979C7.11624 11.6335 6.59149 12.1235 6.21417 12.7207C5.83684 13.3179 5.61965 14.0023 5.58351 14.7078C5.54738 15.4133 5.69351 16.1162 6.00784 16.7488C6.32218 17.3815 6.79411 17.9225 7.37821 18.3199C7.9623 18.7172 8.63886 18.9575 9.34274 19.0175C10.0466 19.0775 10.7541 18.9552 11.397 18.6625C12.0399 18.3698 12.5967 17.9165 13.0136 17.3462M14.7004 6.69057C14.7004 7.12703 14.8737 7.5456 15.1824 7.85422C15.491 8.16284 15.9096 8.33622 16.346 8.33622C16.7825 8.33622 17.201 8.16284 17.5097 7.85422C17.8183 7.5456 17.9917 7.12703 17.9917 6.69057C17.9917 6.25412 17.8183 5.83554 17.5097 5.52692C17.201 5.2183 16.7825 5.04492 16.346 5.04492C15.9096 5.04492 15.491 5.2183 15.1824 5.52692C14.8737 5.83554 14.7004 6.25412 14.7004 6.69057Z", stroke: "#051851", strokeWidth: "1.4", strokeLinecap: "round", strokeLinejoin: "round", fill: "none" }),
    react.createElement("path", { d: "M17.9917 18.2099L14.7004 14.0957H11.409L13.8775 9.9816L10.5862 7.51312L7.29492 8.33595", stroke: "#051851", strokeWidth: "1.4", strokeLinecap: "round", strokeLinejoin: "round", fill: "none" })));



;// CONCATENATED MODULE: ../../../packages/hermes-web-components/lib/icons/Videotape/index.esm.js




const VideotapeIcon = (_a) => {
    var props = (0,_tslib_esm/* __rest */._)(_a, []);
    return (react.createElement(SvgIcon_esm/* default */.Z, Object.assign({ width: "24", height: "25", viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react.createElement("circle", { cx: "12", cy: "12.0928", r: "7.71836", stroke: "#051851", strokeWidth: "1.2", fill: "none" }),
        react.createElement("circle", { cx: "12.0005", cy: "7.86035", r: "1.43408", stroke: "#051851", fill: "none" }),
        react.createElement("circle", { cx: "11.9995", cy: "12.0928", r: "0.70459", fill: "#051851" }),
        react.createElement("circle", { cx: "8.1333", cy: "10.7383", r: "1.43408", stroke: "#051851", fill: "none" }),
        react.createElement("circle", { cx: "9.48486", cy: "15.3882", r: "1.43408", stroke: "#051851", fill: "none" }),
        react.createElement("circle", { cx: "15.8677", cy: "10.7383", r: "1.43408", stroke: "#051851", fill: "none" }),
        react.createElement("circle", { cx: "14.4419", cy: "15.3882", r: "1.43408", stroke: "#051851", fill: "none" }),
        react.createElement("path", { d: "M20.4336 21.0257C19.6682 20.437 17.5301 19.3374 15.1005 19.6483C12.671 19.9592 11.0277 19.7779 10.5098 19.6483", stroke: "#051851", strokeWidth: "1.2", strokeLinecap: "round" })));
};



;// CONCATENATED MODULE: ../../../packages/hermes-web-components/lib/icons/Cup/index.esm.js




const CupIcon = (_a) => {
    var props = (0,_tslib_esm/* __rest */._)(_a, []);
    return (react.createElement(SvgIcon_esm/* default */.Z, Object.assign({ width: "24", height: "25", viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react.createElement("path", { d: "M4.69141 11.1221H16.377C16.9293 11.1221 17.377 11.5698 17.377 12.1221V14.5137V17.0238C17.377 19.233 15.5861 21.0239 13.377 21.0239H7.69141C5.48227 21.0239 3.69141 19.233 3.69141 17.0239V12.1221C3.69141 11.5698 4.13912 11.1221 4.69141 11.1221Z", stroke: "#051851", strokeWidth: "1.2", fill: "none" }),
        react.createElement("path", { d: "M17.4277 12.5598H19.8642C20.9224 12.5598 21.6479 13.626 21.2595 14.6103L20.8385 15.6771C20.6679 16.1096 20.3063 16.4386 19.8596 16.5676L17.4277 17.2702", stroke: "#051851", strokeWidth: "1.2", fill: "none" }),
        react.createElement("path", { d: "M6.23273 15.3497C6.56411 15.3497 6.83273 15.0811 6.83273 14.7497C6.83273 14.4183 6.56411 14.1497 6.23273 14.1497V15.3497ZM3.74609 15.3497H6.23273V14.1497H3.74609V15.3497Z", fill: "#051851" }),
        react.createElement("path", { d: "M8.60156 14.7959L17.2834 14.7959", stroke: "#051851", strokeWidth: "1.2", strokeLinecap: "round" }),
        react.createElement("path", { d: "M8.43615 8.89456L7.96525 8.14678C7.58429 7.54181 7.69242 6.75068 8.22174 6.27012V6.27012C8.86599 5.68524 8.86599 4.67248 8.22174 4.0876L7.60946 3.53174", stroke: "#051851", strokeLinecap: "round" }),
        react.createElement("path", { d: "M11.9537 8.89456L11.4828 8.14678C11.1019 7.54181 11.21 6.75068 11.7393 6.27012V6.27012C12.3836 5.68524 12.3836 4.67248 11.7393 4.0876L11.127 3.53174", stroke: "#051851", strokeLinecap: "round" })));
};



;// CONCATENATED MODULE: ../../../packages/hermes-web-components/lib/icons/Dumbbell/index.esm.js




const DumbbellIcon = (_a) => {
    var props = (0,_tslib_esm/* __rest */._)(_a, []);
    return (react.createElement(SvgIcon_esm/* default */.Z, Object.assign({ width: "24", height: "25", viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react.createElement("rect", { x: "8.04297", y: "17.5235", width: "2.1208", height: "9.35502", rx: "1.0604", transform: "rotate(180 8.04297 17.5235)", stroke: "#051851", fill: "none" }),
        react.createElement("rect", { x: "15.959", y: "8.16846", width: "2.1208", height: "9.35502", rx: "1.0604", stroke: "#051851", fill: "none" }),
        react.createElement("path", { d: "M5.80469 15.946L5.49029 15.946C4.66187 15.946 3.99029 15.2744 3.99029 14.446L3.99029 11.246C3.99029 10.4176 4.66187 9.74601 5.49029 9.74601L5.80469 9.74601L5.80469 15.946Z", stroke: "#051851", fill: "none" }),
        react.createElement("path", { d: "M18.1973 9.74597L18.5117 9.74597C19.3401 9.74597 20.0117 10.4175 20.0117 11.246L20.0117 14.4459C20.0117 15.2744 19.3401 15.9459 18.5117 15.9459L18.1973 15.9459L18.1973 9.74597Z", stroke: "#051851", fill: "none" }),
        react.createElement("path", { d: "M3.79883 14.2834L3.14497 14.2834C2.59269 14.2834 2.14498 13.8357 2.14498 13.2834L2.14498 12.2982C2.14498 11.7459 2.59269 11.2982 3.14497 11.2982L3.79883 11.2982L3.79883 14.2834Z", stroke: "#051851", fill: "none" }),
        react.createElement("path", { d: "M20.2031 11.4086L20.857 11.4086C21.4093 11.4086 21.857 11.8563 21.857 12.4086L21.857 13.3938C21.857 13.9461 21.4093 14.3938 20.857 14.3938L20.2031 14.3938L20.2031 11.4086Z", stroke: "#051851", fill: "none" }),
        react.createElement("path", { d: "M15.8242 13.5384L8.16868 13.5384", stroke: "#051851", strokeLinecap: "round", strokeLinejoin: "round" }),
        react.createElement("path", { d: "M8.16724 11.608L13.0234 11.608", stroke: "#051851", strokeLinecap: "round", strokeLinejoin: "round" }),
        react.createElement("path", { d: "M14.6243 11.6044L15.8105 11.6044", stroke: "#051851", strokeLinecap: "round", strokeLinejoin: "round" })));
};



// EXTERNAL MODULE: ./utils/strings.ts
var strings = __webpack_require__(5892);
;// CONCATENATED MODULE: ./utils/extractFacilitiesTypes.ts


var facilitiesIcons = {
    general: BedIcon,
    paymentOptions: MoneyBagIcon,
    accessibility: AccessibilityIcon,
    leisureRecovery: VideotapeIcon,
    dining: CupIcon,
    wellbeingRehabilitation: DumbbellIcon
};
var extractFacilitiesTypes = function(facilities, locale) {
    var result = {};
    facilities === null || facilities === void 0 ? void 0 : facilities.forEach(function(item) {
        var ref;
        var subtype = (ref = item.Facility.data) === null || ref === void 0 ? void 0 : ref.subtype;
        var ref1;
        var subtypeKey = (0,strings/* camelCase */.eV)((ref1 = subtype === null || subtype === void 0 ? void 0 : subtype.key) !== null && ref1 !== void 0 ? ref1 : "");
        var type = item.Facility.type;
        var name = item.Facility.name;
        var subtypeName = (subtype === null || subtype === void 0 ? void 0 : subtype.name[locale]) || type;
        if (!result[subtypeName]) {
            var ref2;
            result[subtypeName] = {
                name: (subtype === null || subtype === void 0 ? void 0 : subtype.name) || {},
                type: type,
                Icon: (ref2 = facilitiesIcons === null || facilitiesIcons === void 0 ? void 0 : facilitiesIcons[subtypeKey]) !== null && ref2 !== void 0 ? ref2 : null,
                items: [],
                key: subtypeKey
            };
        }
        result[subtypeName].items.push({
            name: name,
            value: item.value || {},
            pinned: item.pinned
        });
    });
    var resultValues = Object.values(result);
    return {
        facilities: (resultValues === null || resultValues === void 0 ? void 0 : resultValues.filter(function(facility) {
            return facility.type === "Facilities";
        })) || [],
        services: (resultValues === null || resultValues === void 0 ? void 0 : resultValues.filter(function(facility) {
            return facility.type === "Services";
        })) || [],
        parking: (resultValues === null || resultValues === void 0 ? void 0 : resultValues.filter(function(facility) {
            return facility.type === "Parking";
        })) || [],
        pinned: (facilities === null || facilities === void 0 ? void 0 : facilities.filter(function(facility) {
            return facility.pinned;
        })) || []
    };
};
/* harmony default export */ var utils_extractFacilitiesTypes = (extractFacilitiesTypes);


/***/ }),

/***/ 94395:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ filteringProfileDataByPlan; }
/* harmony export */ });
/* harmony import */ var _getImageWithWWW__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62400);
/* harmony import */ var _constants_profile__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50081);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}


var UNCLAIMED_PLANS = [
    _constants_profile__WEBPACK_IMPORTED_MODULE_0__/* .PracticePlans.UNCLAIMED */ .cj.UNCLAIMED,
    _constants_profile__WEBPACK_IMPORTED_MODULE_0__/* .SpecialistPlans.UNCLAIMED */ .FS.UNCLAIMED
];
var BASIC_PLANS = [
    _constants_profile__WEBPACK_IMPORTED_MODULE_0__/* .PracticePlans.ENTRY */ .cj.ENTRY,
    _constants_profile__WEBPACK_IMPORTED_MODULE_0__/* .SpecialistPlans.ENTRY */ .FS.ENTRY
];
var PRO_PLANS = [
    _constants_profile__WEBPACK_IMPORTED_MODULE_0__/* .PracticePlans.ESSENTIALS */ .cj.ESSENTIALS,
    _constants_profile__WEBPACK_IMPORTED_MODULE_0__/* .PracticePlans.PRO */ .cj.PRO,
    _constants_profile__WEBPACK_IMPORTED_MODULE_0__/* .SpecialistPlans.EXPERT */ .FS.EXPERT,
    _constants_profile__WEBPACK_IMPORTED_MODULE_0__/* .SpecialistPlans.EXPERT_PRO */ .FS.EXPERT_PRO
];
// todo: fix complexity
// eslint-disable-next-line complexity
var filteringProfileDataByPlan = function(param) {
    var practice = param.practice, specialist = param.specialist, specialistPractice = param.specialistPractice, practiceSpecialist = param.practiceSpecialist;
    var profile = practice || specialist || specialistPractice || practiceSpecialist;
    var isUnclaimed = UNCLAIMED_PLANS.some(function(plan) {
        return profile === null || profile === void 0 ? void 0 : profile.plan.includes(plan);
    });
    var isBasic = BASIC_PLANS.some(function(plan) {
        return profile === null || profile === void 0 ? void 0 : profile.plan.includes(plan);
    });
    var isPro = PRO_PLANS.some(function(plan) {
        return profile === null || profile === void 0 ? void 0 : profile.plan.includes(plan);
    });
    if (practice) {
        var ref, ref1, ref2, ref3, ref4;
        var transformedPractice = _objectSpread({}, practice);
        delete transformedPractice.reviewCode;
        delete transformedPractice.followersCount;
        var imagesWithWWW = {
            cover: (0,_getImageWithWWW__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((practice === null || practice === void 0 ? void 0 : (ref = practice.images) === null || ref === void 0 ? void 0 : ref.cover) || ""),
            logo: (0,_getImageWithWWW__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((practice === null || practice === void 0 ? void 0 : (ref1 = practice.images) === null || ref1 === void 0 ? void 0 : ref1.logo) || ""),
            images: (practice === null || practice === void 0 ? void 0 : (ref2 = practice.images) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.images) === null || ref3 === void 0 ? void 0 : ref3.map(function(href) {
                return (0,_getImageWithWWW__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(href);
            })) || []
        };
        var resultPractice = _objectSpread({}, transformedPractice, {
            images: imagesWithWWW,
            reviewObject: _objectSpread({}, practice.reviewObject),
            specialists: ((ref4 = practice.specialists) === null || ref4 === void 0 ? void 0 : ref4.map(function(pr) {
                return filteringProfileDataByPlan({
                    practiceSpecialist: pr
                });
            })) || []
        });
        if (isBasic || isUnclaimed) {
            resultPractice.averageRating = 0;
            resultPractice.reviewsTotal = 0;
            resultPractice.overallExperience = 0;
            resultPractice.lastReview = null;
            resultPractice.images.logo = "";
            resultPractice.images.cover = "";
            resultPractice.insurers = [];
            resultPractice.reviewObject = {
                overallExperience: 0,
                reviewsTotal: 0,
                averageRating: 0,
                bedsideManner: 0,
                careAndSupport: 0,
                cleanliness: 0,
                explanation: 0,
                facilities: 0,
                friendliness: 0,
                waitTime: 0
            };
        }
        if (isPro) {
            resultPractice.followersCount = practice.followersCount;
        }
        return resultPractice;
    }
    if (practiceSpecialist) {
        var ref5;
        var transformedPracticeSpecialist = _objectSpread({}, practiceSpecialist);
        delete transformedPracticeSpecialist.reviewCode;
        delete transformedPracticeSpecialist.authenticationToken;
        var imagesWithWWW1 = {
            logo: (0,_getImageWithWWW__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((practiceSpecialist === null || practiceSpecialist === void 0 ? void 0 : (ref5 = practiceSpecialist.images) === null || ref5 === void 0 ? void 0 : ref5.logo) || "")
        };
        var resultPracticeSpecialist = _objectSpread({}, transformedPracticeSpecialist, {
            images: imagesWithWWW1,
            review: _objectSpread({}, practiceSpecialist.review)
        });
        if (isBasic || isUnclaimed) {
            resultPracticeSpecialist.averageRating = 0;
            resultPracticeSpecialist.reviewsTotal = 0;
            resultPracticeSpecialist.overallExperience = 0;
            resultPracticeSpecialist.explanation = 0;
            resultPracticeSpecialist.bedsideManner = 0;
            resultPracticeSpecialist.averageRating = 0;
            resultPracticeSpecialist.lastReview = null;
            resultPracticeSpecialist.images.logo = "";
            resultPracticeSpecialist.insurers = [];
            resultPracticeSpecialist.review = {
                overallExperience: 0,
                reviewsTotal: 0,
                averageRating: 0,
                bedsideManner: 0,
                careAndSupport: 0,
                cleanliness: 0,
                explanation: 0,
                facilities: 0,
                friendliness: 0,
                waitTime: 0
            };
        }
        if (isUnclaimed) {
            resultPracticeSpecialist.registrationBodies = [];
        }
        return resultPracticeSpecialist;
    }
    if (specialist) {
        var ref6, ref7, ref8, ref9, ref10;
        var transformedSpecialist = _objectSpread({}, specialist);
        delete transformedSpecialist.reviewCode;
        delete transformedSpecialist.authenticationToken;
        var imagesWithWWW2 = {
            logo: (0,_getImageWithWWW__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((specialist === null || specialist === void 0 ? void 0 : (ref6 = specialist.images) === null || ref6 === void 0 ? void 0 : ref6.logo) || ""),
            images: (specialist === null || specialist === void 0 ? void 0 : (ref7 = specialist.images) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.images) === null || ref8 === void 0 ? void 0 : ref8.map(function(href) {
                return (0,_getImageWithWWW__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(href);
            })) || []
        };
        var resultSpecialist = _objectSpread({}, transformedSpecialist, {
            images: imagesWithWWW2,
            review: _objectSpread({}, specialist.review),
            practices: ((ref9 = specialist.practices) === null || ref9 === void 0 ? void 0 : ref9.map(function(pr) {
                return filteringProfileDataByPlan({
                    specialistPractice: pr
                });
            })) || []
        });
        resultSpecialist.peerRecommendations = (resultSpecialist === null || resultSpecialist === void 0 ? void 0 : (ref10 = resultSpecialist.peerRecommendations) === null || ref10 === void 0 ? void 0 : ref10.slice(0, 3)) || [];
        if (isBasic || isUnclaimed) {
            resultSpecialist.averageRating = 0;
            resultSpecialist.reviewsTotal = 0;
            resultSpecialist.overallExperience = 0;
            resultSpecialist.lastReview = null;
            resultSpecialist.insurers = [];
            resultSpecialist.review = {
                overallExperience: 0,
                reviewsTotal: 0,
                averageRating: 0,
                bedsideManner: 0,
                careAndSupport: 0,
                cleanliness: 0,
                explanation: 0,
                facilities: 0,
                friendliness: 0,
                waitTime: 0
            };
        }
        if (isUnclaimed) {
            resultSpecialist.registrationBodies = [];
        }
        return resultSpecialist;
    }
    if (specialistPractice) {
        var ref11, ref12, ref13, ref14;
        var transformedSpecialistPractice = _objectSpread({}, specialistPractice);
        delete transformedSpecialistPractice.reviewCode;
        delete transformedSpecialistPractice.authenticationToken;
        var imagesWithWWW3 = {
            cover: (0,_getImageWithWWW__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((specialistPractice === null || specialistPractice === void 0 ? void 0 : (ref11 = specialistPractice.images) === null || ref11 === void 0 ? void 0 : ref11.cover) || ""),
            logo: (0,_getImageWithWWW__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((specialistPractice === null || specialistPractice === void 0 ? void 0 : (ref12 = specialistPractice.images) === null || ref12 === void 0 ? void 0 : ref12.logo) || ""),
            images: (specialistPractice === null || specialistPractice === void 0 ? void 0 : (ref13 = specialistPractice.images) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.images) === null || ref14 === void 0 ? void 0 : ref14.map(function(href) {
                return (0,_getImageWithWWW__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(href);
            })) || []
        };
        var resultSpecialistPractice = _objectSpread({}, transformedSpecialistPractice, {
            images: imagesWithWWW3,
            reviews: _objectSpread({}, specialistPractice.reviews)
        });
        if (isBasic || isUnclaimed) {
            resultSpecialistPractice.images.logo = "";
            resultSpecialistPractice.reviews = {
                overallExperience: 0,
                reviewsTotal: 0,
                averageRating: 0,
                bedsideManner: 0,
                careAndSupport: 0,
                cleanliness: 0,
                explanation: 0,
                facilities: 0,
                friendliness: 0,
                waitTime: 0
            };
        }
        return resultSpecialistPractice;
    }
    return undefined;
};


/***/ }),

/***/ 99744:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ practiceSpecialistSort; },
/* harmony export */   "V": function() { return /* binding */ getPracticeSpecialistName; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var practiceSpecialistSort = function(specialists) {
    return _toConsumableArray(specialists.filter(function(_, index) {
        return index % 2 === 0;
    })).concat(_toConsumableArray(specialists.filter(function(_, index) {
        return index % 2 !== 0;
    })));
};
var getPracticeSpecialistName = function(specialist, language) {
    var ref, ref1, ref2;
    return [
        specialist === null || specialist === void 0 ? void 0 : (ref = specialist.title) === null || ref === void 0 ? void 0 : ref[language],
        specialist === null || specialist === void 0 ? void 0 : (ref1 = specialist.firstName) === null || ref1 === void 0 ? void 0 : ref1[language],
        specialist === null || specialist === void 0 ? void 0 : (ref2 = specialist.lastName) === null || ref2 === void 0 ? void 0 : ref2[language]
    ].filter(function(n) {
        return !!n;
    }).join(" ");
};


/***/ })

}]);